import StoreContentPage from '../components/content/StoreContentPage';

export default function PrivacyPolicy() {
  return (
    <StoreContentPage
      contentKey="privacy"
      title="Privacy Policy"
      fallback={
        <>
          <h1 className="font-display" style={{ margin: 0, fontSize: 'clamp(2rem,4vw,3.25rem)' }}>Privacy Policy</h1>
          <p style={{ marginTop: '1rem', opacity: 0.78, lineHeight: 1.75 }}>
            We collect personal information only when needed to provide core storefront services such as checkout,
            payment processing, customer support, and account management. We do not sell personal data. Information is
            handled in line with applicable data protection laws.
          </p>
          <p style={{ opacity: 0.78, lineHeight: 1.75 }}>
            You can request access, correction, or deletion of your personal data by contacting support through the
            contact page.
          </p>
        </>
      }
    />
  );
}
